import PlageCreneau from '@/generated/classes/PlageCreneau';
export default class PlageCreneauExtend extends PlageCreneau {
  constructor() {
    super();
  }
}
